import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';


@Injectable({
  providedIn: 'root'
})
export class BackgroundVerificationService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) {
    try {
      environment.API_URL = this.session.GetUserDetails().ApiUrl;
    } catch (e) { }
  }

  ESS_BGVFillCombo(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_BGVFill/Combo`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_bgvPolicyInsertUpdate(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_bgvPolicyInsert/Update`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_bgvPolicyLoad(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_bgvPolicy/Load`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_BGVCheckListUpdate(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_BGVCheckList/Update`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpBgvMandatoryDataLoad(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpBgvMandatoryData/Load`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpBGVVerificationDetailsSelect(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpBGVVerificationDetails/Select`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpBGVManualVerificationDetailsInsert(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpBGVManualVerificationDetails/Insert`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
